import React from 'react'

const AdminDrashboard = () => {
  return (
    <div>AdminDrashboard</div>
  )
}

export default AdminDrashboard